import Router from './routes.js';
import "./App.css";

function App() {
  return (
    <Router />
  );
}

export default App;
